/**
 * 接口枚举定义（来源 docs/swagger.json definitions）
 * 所有枚举以 E 开头，与后端 app.* 对应
 */

/** 余额类型 (swagger: app.BalanceType) */
export enum EBalanceType {
  /** 交易余额 */
  Balance1 = 1,
  /** 可提余额 */
  Balance2 = 2,
  /** 冻结资产(冻结提现) */
  FreezeBalance = 3,
}

/** 审核/提现状态 (swagger: app.CheckStatusType) */
export enum ECheckStatusType {
  /** 待审核 */
  Wait = 1,
  /** 审核通过 */
  Pass = 2,
  /** 审核驳回 */
  NotPass = 3,
  /** 已取消(取消提现) */
  Cancel = 4,
  /** 提现成功 */
  Success = 5,
  /** 提现失败 */
  Fail = 6,
}

/** 币种简称 (swagger: app.CoinAlias) */
export enum ECoinAlias {
  /** 以太坊 */
  ETH = 'ETH',
  /** 波场 */
  TRX = 'TRX',
  /** ERC20-USDT */
  ERC20USDT = 'ERC20-USDT',
  /** ERC20-USDC */
  ERC20USDC = 'ERC20-USDC',
  /** TRC20-USDT */
  TRC20USDT = 'TRC20-USDT',
}

/** 流水类型 (swagger: app.FlowType) */
export enum EFlowType {
  /** 充值usdt */
  RechargeUsdt = 1,
  /** 提现usdt */
  WithdrawUsdt = 2,
  /** 提现usdt返还 */
  WithdrawUsdtReturn = 3,
  /** 平台操作 */
  Station = 10,
  /** 人工充值 */
  ManualAdd = 11,
  /** 购买产品 */
  Buy = 20,
  /** 产品收益 */
  BuyIncome = 21,
  /** 团队佣金 */
  GroupReward = 22,
  /** 奖励赠送 */
  Reward = 23,
  /** 邀请注册奖励 */
  InviteRegisterReward = 24,
  /** 直属下级首充奖励 */
  DownFirstRechargeReward = 25,
  /** 团队长奖励 */
  TeamLeaderReward = 26,
}

/** 个人等级 (swagger: app.LevelType) */
export enum ELevelType {
  /** VIP1 */
  Level1 = 1,
  /** VIP2 */
  Level2 = 2,
  /** VIP3 */
  Level3 = 3,
  /** VIP4 */
  Level4 = 4,
  /** VIP5 */
  Level5 = 5,
  /** VIP6 */
  Level6 = 6,
}

/** 网络类型 (swagger: app.NetworkType) */
export enum ENetworkType {
  /** 以太坊 */
  ETH = 'ETH',
  /** 波场 */
  TRX = 'TRX',
}

/** 上下架状态 (swagger: app.OnSellType) */
export enum EOnSellType {
  /** 上架 */
  On = 1,
  /** 下架 */
  Off = 2,
}

/** 产品订单状态 (swagger: app.ProductOrderStatus) */
export enum EProductOrderStatus {
  /** 待启动 */
  Pending = 1,
  /** 进行中 */
  InProgress = 2,
  /** 已完成 */
  Completed = 3,
  /** 已失效 */
  Expired = 4,
}

/** 充值类型 (swagger: app.RechargeType) */
export enum ERechargeType {
  /** 链上充值 */
  Chain = 1,
  /** 人工充值 */
  Manual = 2,
}

/** 代币类型 (swagger: app.TokenType) */
export enum ETokenType {
  /** 以太坊代币 */
  ERC20 = 'ERC20',
  /** 波场代币 */
  TRC20 = 'TRC20',
}

/** 用户状态 (swagger: app.UserStatusType) */
export enum EUserStatusType {
  /** 启用 */
  Enable = 1,
  /** 禁用 */
  Disable = 2,
}

/** 用户类型 (swagger: app.UserType) */
export enum EUserType {
  /** 外部用户 */
  Real = 1,
  /** 内部用户 */
  Fake = 2,
}
